<template>
  <div class="sf-form-group tw-pb-4 md:tw-grid md:tw-grid-cols-2 md:tw-gap-4">
    <div>
      <label class="!tw-inline md:tw-block">
        How many {{ subject }} classes do you wish to {{ labelAction }}?
      </label>
      <div class="!tw-inline md:tw-block">
        {{ $filters.renderMoney(classCost) }} / class
      </div>
    </div>
    <div :class="{ 'tw-grid tw-grid-cols-2 tw-gap-4': mode == 'addclasses' }">
      <input
        type="number"
        v-model="classCount"
        @change="evaluateMinClasses"
        class="sf-form-control tw-w-full"
        min="0"
      />
      <div v-if="mode == 'addclasses'" class="tw-pt-4">
        {{ totalCount }} classes in total
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { SfPurchaseType } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    subject: { type: String as PropType<"spelling" | "maths">, required: true },
    mode: { type: String as PropType<SfPurchaseType>, required: true },
    classCost: { type: Number, required: true },
    modelValue: { type: Number, required: true },
    currentSubscriptionClassCount: { type: Number, required: true },
  },
  data() {
    return {
      classCount: 0,
    };
  },
  computed: {
    labelAction() {
      if (this.mode == "activation" || this.mode == "extend") {
        return "purchase for the next 12 months";
      } else if (this.mode == "addclasses") {
        return "add classes to your subscription";
      }
      return "";
    },
    totalCount() {
      return this.classCount + this.currentSubscriptionClassCount;
    },
  },
  mounted() {
    this.classCount = this.modelValue;
  },
  methods: {
    evaluateMinClasses() {
      if (this.classCount < 0) {
        this.classCount = 0;
      }
      this.$emit("update:modelValue", this.classCount);
    },
  },
});
</script>
